import { AutogenLayoutRenditionPickList } from "./autogen/AutogenLayoutRenditionPickList";
import {  ClickEvent,  KeyEvent,  DropdownSelectionEvent,  TableSelectionEvent, TableRow } from "@mcleod/components";
import { Checkbox, DropdownItem, DataDisplayEvent, Label, StepEvent, Textbox, DataSourceExecutionEvent, Layout, Panel, TableRowExpansionEvent, Button, HorizontalSpacer } from "@mcleod/components";
import { Router, CommonDialogs } from "@mcleod/common";
import { AutogenLayoutEdiBatchHistoryQuickInfoTable } from "../../../mcleod-ui-lme/datafusion/src/autogen/AutogenLayoutEdiBatchHistoryQuickInfoTable";
import { AutogenLayoutRenditionBilling } from "./autogen/AutogenLayoutRenditionBilling";
import { RenditionBilling } from "./RenditionBilling";
import { RenditionBillingDetail } from "./RenditionBillingDetail";
import { Navigation } from "@mcleod/core";

export class RenditionPickList extends AutogenLayoutRenditionPickList {
    private viewType: any = "pdf";
    private selRow: number;
    private billto: any = null;
    private ids = [];

    //private rb = new RenditionBilling();
    override onLoad() {
        this.PdfTifSwitch.checked = true;
        this.txtOrder.focus();
        this.DelItemButton.enabled = false;
    }
/** This is an event handler for the onClick event of DelItemButton. */
  DelItemButtonOnClick(event: ClickEvent) {
    if( this.selRow >= 0 )
    {
        this.table1.removeRow( this.selRow );
        if( this.table1.rowCount == 0 )
            this.billto = null;
    }
  }

/** This is an event handler for the onChange event of PdfTifSwitch. */
  PdfTifSwitchOnChange(event) {
    if( event.newValue == true )
        this.viewType = "tif";
    else
        this.viewType = "pdf";
    //console.log( this.viewType );
  }

/** This is an event handler for the onClick event of ProcessButton. */
  ProcessButtonOnClick(event: ClickEvent) {
    //const ids = [];
    // for (let i = 0; i < this.table1.rowCount; i++)
    // {
    //     //const order = this.table1.rows[i].data.renb_load_no;
    //     //const billto = this.table1.rows[i].data.renb_bill_to;
    //     const id = this.table1.rows[i].data.renbid;
    //     this.ids.push( id );
    // }
    // if (this.ids.length > 0) {
    //     const procType = "E";
    //     const selPrinter = "imp";
    //     const rb:any = RenditionBilling.instance;// Layout.getLayout( "imaging/RenditionBilling" ) as RenditionBilling;
    //     rb.pickListClose(this.ids);
    //     window.close();
    //     //const rb = Layout.getLayout( "imaging/RenditionBilling" ) as RenditionBilling;
    //     //const screen = window. ( Router.homePage ) as RenditionBilling;
    //     //RenditionBilling.pickListProcess( ids, procType, selPrinter );

    //     //this.sourceProcess.search({ ids: ids, ErrorHandler: null, proctype: procType, selectedprinter: selPrinter }).then(() => {
    //     //this.stepperMain.selectedIndex = 1;
    //     //});
    // }
}

/** This is an event handler for the onKeyDown event of txtOrder. */
  async txtOrderOnKeyDown(event: KeyEvent) {
    if( event.key == "Enter" )
    {
        let resp: any = null;
        if( this.billto == null )
            resp = await this.sourceProcbills.search({ renb_load_no: this.txtOrder.text });
        else
            resp = await this.sourceProcbills.search({ renb_load_no: this.txtOrder.text, renb_bill_to: this.billto });
        if( resp.modelRows.length > 0 )
        {
            let found = 0;
            for (let i = 0; i < this.table1.rowCount; i++)
            {
                if( this.table1.rows[i].data.renb_load_no == this.txtOrder.text )
                {
                    found = 1;
                    break;
                }
            }
            if( found == 0 )
            {
                this.billto = resp.modelRows[0]._data.renb_bill_to;
                const id = resp.modelRows[0]._data.renb_id;
//                const row = { renb_load_no: this.txtOrder.text, renb_bill_to: this.billto };
                const row = { renb_load_no: this.txtOrder.text, renb_bill_to: this.billto, renbid: id };
                this.table1.addRow( row, null, { display: true, addToData: false });
                this.txtOrder.text = "";
            }
        }
        else
        {
            const props = { panelTitleProps: { backgroundColor: "primary.darker", color: "primary.reverse" } };
            if( this.billto == null )
                CommonDialogs.showMessage("No records found for[" + this.txtOrder.text + "]", "Document Power", props);
            else
                CommonDialogs.showMessage("No records found for[" + this.txtOrder.text + "][" + this.billto + "]", "Document Power", props );
        }
    }
  }

/** This is an event handler for the onSelect event of table1. */
  table1OnSelect(event: TableSelectionEvent) {
    if( event.newRow )
    {
        this.selRow = event.newRow.index;
        this.DelItemButton.enabled = true;
    }
    else
    {
        this.selRow = -1;
        this.DelItemButton.enabled = false;
    }
    //console.log( this.selRow );
  }
}
